import React, { useState, useEffect } from "react";
import {
    Form,
    Row,
    Col,
    Skeleton,
    Select,
    Input,
    Button,
    Modal,
    InputNumber,
    Alert,
} from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
import DatePicker from "@general/datePicker";

function AddMessage() {


    const CREATEMESSAGE = gql`
        mutation createMessage($createInput: CreateMessageInput!) {
            createMessage(createInput: $createInput) {
                id
                expiresAt
            }
        }
  `;
    const GETUSERS = gql`
    query ($paginateInput: PaginateInput!, $searchInput: UserSearchInput!) {
      getUsers(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        mobile
      }
    }
  `;
    const [error, setError] = useState(null);
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [selectableUsers, setSelectableUsers] = useState([]);

    const [runCreateBthMessage, createBthMessage] = useMutation(CREATEMESSAGE, {
        onCompleted(data) {
            Modal.success({
                title: "موفق",
                content: "پیام اطلاع رسانی ایجاد شد",
                bodyStyle: { direction: "rtl" },
                okText: "باشه",
                onOk: () => form.resetFields(),
            });

        },
        onError(err) {
            console.log("خطا: " + err.message);
            Modal.error({
                title: "مشکلی پیش آمده!",
                content: err.message,
                bodyStyle: { direction: "rtl" },
                okText: "باشه",
            });
        },
    });

    const [getUsers, users] = useLazyQuery(
        GETUSERS,
        {
            fetchPolicy: "no-cache",
            onCompleted({ getUsers }) {
                const arrangedUsers = [{ value: "all", label: "همه کاربران" }];
                getUsers.map((user) => {
                    arrangedUsers.push({
                        value: user.id,
                        label: user.name ? user.name : user.mobile,
                    });
                });
                setSelectableUsers(arrangedUsers);
            },
        }
    );
    useEffect(() => {
        getUsers({
            variables: {
                paginateInput: {
                    page: 1,
                    perPage: 500,
                },
                searchInput: {
                    userRole: 'USER'
                }
            },
        });
    }, []);
    const doCreateMessage = (createInput) => {
        if (createInput.userIds[0] === "all" || createInput.userIds === "all") createInput.userIds = [];
        runCreateBthMessage({
            variables: {
                createInput: {
                    ...createInput,
                    expiresAt: createInput.expiresAt ?? null,
                    type: 'BROADCAST'
                },
            },
        });

    };

    return (
        <>
            <Form layout="vertical" onFinish={doCreateMessage} form={form}>
                <Row>
                    <Col xs={12} md={12}>

                        <Row>
                            <Form.Item
                                name="title"
                                id="title"
                                style={{ width: "100%" }}
                                label="عنوان"
                                rules={[
                                    {
                                        required: true,
                                        message: "لطفا عنوان را وارد کنید!",
                                    },
                                ]}
                                validateStatus={error && "error"}
                            >
                                <Input className="form-input" placeholder={"عنوان"} />
                            </Form.Item>
                        </Row>

                        <Row>
                            <Form.Item
                                name="body"
                                id="body"
                                style={{ width: "100%" }}
                                label="پیام"
                                rules={[
                                    {
                                        required: true,
                                        message: "لطفا پیام را وارد کنید!",
                                    },
                                ]}
                                validateStatus={error && "error"}
                            >
                                <TextArea placeholder="پیام" rows={3} />

                            </Form.Item>
                        </Row>


                        <Row> <Col xs={12} md={12}>
                            <Form.Item
                                name="userIds"
                                id="userIds"
                                label="کاربران مشمول"
                                rules={[
                                    {
                                        required: true,
                                        message: "لطفا نام کاربران دریافت کننده پیام را انتخاب کنید!",
                                    },
                                ]}
                                validateStatus={error && "error"}
                            >
                                <Select
                                    showSearch
                                    mode="multiple"
                                    allowClear
                                    loading={users.loading}
                                    listHeight={200}
                                    style={{
                                        width: 280,
                                    }}
                                    placeholder={"کاربران"}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").includes(input)
                                    }
                                    filterSort={(optionB, optionA) =>
                                        (optionA?.label ?? "")
                                            .toLowerCase()
                                            .localeCompare((optionB?.label ?? "").toLowerCase())
                                    }
                                    options={selectableUsers}
                                />
                            </Form.Item></Col>
                            <Col xs={12} md={12}>
                                <Form.Item
                                    label="تاریخ انقضا"
                                    name="expiresAt"
                                >
                                    <DatePicker
                                        showToday={false}
                                        format="YYYY/MM/DD"
                                        className="rtl"
                                        placeholder="تاریخ انقضا"
                                        disabledDate={(current) => current < moment().endOf("day")}
                                    />
                                </Form.Item></Col>
                        </Row>



                    </Col>

                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <Alert
                            description="USER_NAME = نام و نام خانوادگی"
                            type="info"
                            banner
                            style={{ width: "100%", marginBottom: "30px" }}
                        /></Col>
                </Row>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={createBthMessage.loading || createBthMessage.loading && true}
                >
                    ثبت
                </Button>
            </Form>
        </>
    );
}

export default AddMessage;
